import {
  ChainID,
  Chain,
  ChainURL,
  EnrichedChainURL,
} from '@ankr.com/chains-list';

export interface ChainGroup {
  id: ChainGroupID;
  name: string;
  pluralName: string;
  chains: ChainID[];
}

export enum ChainGroupID {
  C_CHAIN = 'c-chain',
  ETH_MAINNET = 'eth-mainnet',
  GOERLI = 'goerli',
  GRPC = 'grpc',
  HORIZEN = 'horizen',
  JSON_RPC = 'json-rpc',
  KOVAN = 'kovan',
  NEAR = 'near',
  NERVOS_CKB = 'nervos-ckb',
  NERVOS_EVM = 'nervos-evm',
  NERVOS_GW = 'nervos-gw',
  P_CHAIN = 'p-chain',
  REST_API = 'rest-api',
  RINKEBY = 'rinkeby',
  ROPSTEN = 'ropsten',
  HOLESKY = 'holesky',
  HOODI = 'hoodi',
  TENDERMINT_RPC = 'tendermint-rpc',
  TENDERMINT_REST = 'tendermint-rest',
  TENDERMINT_GRPC = 'tendermint-grpc',
  COSMOS_REST = 'cosmos-rest',
  SEPOLIA = 'sepolia',
  SOLANA = 'solana',
  SOLANA_DEVNET = 'solana_devnet',
  STANDARD_EVM = 'standard-evm',
  X_CHAIN = 'x-chain',
  SUI_MAINNET = 'sui_mainnet',
  SUI_TESTNET = 'sui_testnet',
  TENET = 'tenet',
  SCROLL_ALPHA = 'scroll_testnet',
  KAVA_COSMOS_REST = 'kava-cosmos-rest',
  KAVA_EVM = 'kava-evm',
  KAVA_TENDERMINT_REST = 'kava-tendermint-rest',
  KAVA_TENDERMINT_RPC = 'kava-tendermint-rpc',
  STELLAR_HORIZON = 'stellar-horizon',
  STELLAR_RPC = 'stellar-rpc',
  MUMBAI = 'mumbai',
  AMOY = 'amoy',
  CARDONA = 'cardona',
  POLYGON_TESTNET = 'testnet',
  FLARE_COSTON = 'flare-coston',
  FLARE_COSTON2 = 'flare-coston2',
  FLARE_SONGBIRD = 'flare-songbird',
  GOLDBERG = 'goldberg',
  TURING = 'turing',
  BTC = 'btc',
  BTC_BLOCKBOOK = 'btc_blockbook',
  BEACONKIT_REST = 'beaconkit_rest',
  TON_REST = 'ton_rest',
  TON_RPC = 'ton_rpc',
  FUEL_GRAPH_QL = 'fuel-graph-ql',
  MAIZENET = 'maizenet',
  BOTANIX = 'botanix',
  TAC = 'tac',
  EVM_JSON_RPC = 'evm_json_rpc',
  MOVEMENT_MAINNET = 'movement_mainnet',
  MOVEMENT_BARDOCK = 'movement_bardock',
  TAC_SPB = 'tac-spb',
  BAKLAVA = 'baklava',
  ZKVERIFY = 'zkverify',
  VFLOW = 'vflow',
  VFLOW_PARACHAIN = 'vflow_parachain',
  VOLTA = 'volta',
  SHADOWNET = 'shadownet',
  ETHERLINK_TESTNET = 'etherlink_testnet',
  POLKADOT = 'polkadot',
  POLKADOT_ASSET_HUB = 'polkadot_asset_hub',
  VRPC = 'vrpc',

  FALLBACK = 'FALLBACK',
  MERGED = 'MERGED', // for internal use only. covers case with multiple endpoints for the same chain when we don't want to show them as separate groups
}

export interface EndpointGroup {
  chainName: string;
  id: ChainGroupID;
  name: ChainGroup['name'];
  pluralName: ChainGroup['pluralName'];
  urls: (ChainURL | EnrichedChainURL)[];
  urlsCount: number;
  chains: Chain[];
  beacons?: EndpointGroup[];
  opnodes?: EndpointGroup[];
}

export interface GroupedEndpoints {
  mainnet: EndpointGroup[];
  testnet: EndpointGroup[];
  devnet: EndpointGroup[];
  signet: EndpointGroup[];
  beaconsMainnet: EndpointGroup[];
  opnodesMainnet: EndpointGroup[];
  beaconsTestnet: EndpointGroup[];
  opnodesTestnet: EndpointGroup[];
}
